import { CalendarToday } from '@mui/icons-material';
import {
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography,
  Box,
  InputAdornment,
  Button,
  Modal,
} from '@mui/material';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { getLabelsByInstituteType } from '../../utils/constants';
import { useEffect, useState } from 'react';
import { getClasses } from '../../features/classes/ClassSlice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { Field, Form, Formik } from 'formik';
import {
  SetClassesInfo,
  StudentsList,
} from '../../features/attendance/AttendanceSlice';
import { MenuProps } from '../../utils/constants';
export function AttendanceHeader({
  searchValues,
  Loading,
  setSearchValues,
  submitted,
  setHasChanges,
  hasChanges,
}) {
  const { attendanceData, classesInformation } = useSelector(
    (state) => state.attendance,
  );
  //const [classes, setClasses] = useState(attendanceData ? 1 : 0);
  const [classDetails, setClassDetails] = useState(
    attendanceData ? (classesInformation ? classesInformation : []) : [],
  );
  let tempDepartment = [];
  let tempClasses = [];
  let tempSections = [];
  if (attendanceData) {
    tempDepartment = classesInformation?.find(
      (obj) => obj.department === attendanceData.departmentName,
    );
    tempClasses = tempDepartment?.classes;
    const selectedClass = tempClasses?.find(
      (obj) => obj.className === attendanceData.className,
    );
    tempSections = selectedClass?.sections;
  }
  const [currentDepartment, setCurrentDepartment] = useState(tempDepartment);
  const [currentClasses, setCurrentClasses] = useState(tempClasses);
  const [currentSections, setCurrentSections] = useState(tempSections);
  const [change, setChange] = useState(hasChanges);
  const [currentValues, setCurrentValues] = useState(searchValues);
  const dispatch = useDispatch();
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  let { Department, Class, Section } = getLabelsByInstituteType(instituteType);
  useEffect(() => {
    (async () => {
      const response = await dispatch(getClasses()).unwrap();
      response == 'error' ? setClassDetails([]) : setClassDetails(response);
      if (response !== 'error') {
        await dispatch(SetClassesInfo(response));
      }
    })();
  }, []);
  async function getStudents(values) {
    try {
      await dispatch(
        StudentsList({ ...values, instituteType: instituteType }),
      ).unwrap();
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <>
      <Card className='  rounded  shadow-none mr-auto  pl-0 '>
        <CardContent className='pl-0'>
          <Typography variant='h6' className='mb-2 '>
            Select Class Details
          </Typography>
          <Formik
            initialValues={currentValues}
            enableReinitialize={true}
            validationSchema={Yup.object({
              departmentName: Yup.string().required(`Select ${Department} `),
              className: Yup.string().required(`Select ${Class} `),
              sectionName:
                instituteType?.toLowerCase() == 'college'
                  ? Yup.string().required(`Select ${Section}`)
                  : Yup.string(),
              attendanceDate: Yup.date()
                .required(`Select Date `)
                .max(new Date(), 'Date cannot be in the future'),
            })}
            onSubmit={async (values) => {
              setCurrentValues({ ...values });
              if (hasChanges) {
                setChange(true);
              } else {
                getStudents(values);
                setSearchValues({ ...values });
              }
            }}
          >
            {({ setFieldValue }) => (
              <Form>
                <Box className='grid grid-cols-1 min-[550px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 gap-y-0 max-w-[1000px] '>
                  <Field name='departmentName'>
                    {({ field, meta }) => (
                      <FormControl
                        fullWidth
                        size='small'
                        error={meta.touched && Boolean(meta.error)}
                      >
                        <InputLabel id='class-label' className='font-medium'>
                          {Department}
                        </InputLabel>
                        <Select
                          MenuProps={MenuProps}
                          labelId='class-label'
                          {...field}
                          value={field.value || searchValues.departmentName}
                          label={Department}
                          onChange={(e) => {
                            const dept = classDetails?.find(
                              (obj) => obj.department === e.target.value,
                            );
                            setCurrentDepartment(dept);
                            setCurrentClasses(dept?.classes);
                            setFieldValue('departmentName', e.target.value);
                            setFieldValue('className', '');
                            setFieldValue('sectionName', '');
                          }}
                        >
                          {classDetails?.length == 0 && (
                            <MenuItem value=''>{` No ${Department} Available`}</MenuItem>
                          )}
                          {classDetails?.length > 0 &&
                            classDetails?.map((obj) => (
                              <MenuItem key={obj.id} value={obj.department}>
                                {obj.department}
                              </MenuItem>
                            ))}
                        </Select>
                        {meta.touched && meta.error && (
                          <small className='text-red-600'>{meta.error}</small>
                        )}
                      </FormControl>
                    )}
                  </Field>

                  <Field name='className'>
                    {({ field, meta }) => (
                      <FormControl
                        fullWidth
                        size='small'
                        error={meta.touched && Boolean(meta.error)}
                      >
                        <InputLabel id='class-label' className='font-medium'>
                          {Class}
                        </InputLabel>
                        <Select
                          MenuProps={MenuProps}
                          labelId='class-label'
                          {...field}
                          value={field.value}
                          label={Class}
                          onChange={(e) => {
                            const Class = currentClasses?.find(
                              (obj) => obj.className === e.target.value,
                            );
                            setCurrentSections(Class?.sections);
                            setFieldValue('className', e.target.value);
                            setFieldValue('sectionName', '');
                          }}
                        >
                          {currentClasses?.length == 0 && (
                            <MenuItem value=''>{` --- Select  ${Department} ---`}</MenuItem>
                          )}
                          {currentDepartment?.classes?.map((obj) => (
                            <MenuItem key={obj.id} value={obj.className}>
                              {obj.className}
                            </MenuItem>
                          ))}
                        </Select>
                        {meta.touched && meta.error && (
                          <small className='text-red-600'>{meta.error}</small>
                        )}
                      </FormControl>
                    )}
                  </Field>

                  {instituteType.toLowerCase() === 'college' && (
                    <Field name='sectionName'>
                      {({ field, meta }) => (
                        <FormControl
                          fullWidth
                          size='small'
                          error={meta.touched && Boolean(meta.error)}
                        >
                          <InputLabel id='class-label' className='font-medium'>
                            {Section}
                          </InputLabel>
                          <Select
                            MenuProps={MenuProps}
                            labelId='class-label'
                            {...field}
                            value={field.value}
                            label={Section}
                            onChange={(e) => {
                              setFieldValue('sectionName', e.target.value);
                            }}
                          >
                            {currentSections?.length == 0 && (
                              <MenuItem value=''>{` --- Select  ${Class} ---`}</MenuItem>
                            )}
                            {currentSections?.map((obj) => (
                              <MenuItem key={obj.id} value={obj.section}>
                                {obj.section}
                              </MenuItem>
                            ))}
                          </Select>
                          {meta.touched && meta.error && (
                            <small className='text-red-600'>{meta.error}</small>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  )}

                  <Field name='attendanceDate'>
                    {({ field, form, meta }) => (
                      <div className=''>
                        <DatePicker
                          selected={field.value ? new Date(field.value) : null}
                          onChange={(val) => {
                            if (val instanceof Date && !isNaN(val)) {
                              // Fix timezone offset issue by subtracting the timezone offset in ms
                              const correctedDate = new Date(
                                val.getTime() - val.getTimezoneOffset() * 60000,
                              );
                              form.setFieldValue(
                                field.name,
                                correctedDate.toISOString().split('T')[0],
                              );
                            } else {
                              form.setFieldValue(field.name, null);
                            }
                          }}
                          onCalendarClose={() =>
                            setTimeout(() => {
                              form.setFieldTouched(field.name, true, true);
                            }, 0)
                          }
                          placeholderText='DD-MM-YYYY'
                          dateFormat='dd/MM/yyyy'
                          isClearable={!!field.value}
                          showMonthDropdown
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={51} // 1980 → 2030 inclusive
                          dropdownMode='scroll'
                          minDate={new Date(1980, 0, 1)}
                          maxDate={new Date()}
                          wrapperClassName='w-full bg-white'
                          autoComplete='off'
                          customInput={
                            <TextField
                              error={
                                submitted ||
                                (meta.touched && Boolean(meta.error))
                              }
                              helperText={
                                meta.touched && meta.error ? (
                                  <small className='text-red-600 text-[13px]'>
                                    {meta.error}
                                  </small>
                                ) : (
                                  ''
                                )
                              }
                              slotProps={{
                                input: {
                                  endAdornment: (
                                    <InputAdornment position='end'>
                                      {!field.value ? (
                                        <CalendarToday className='size-5 text-gray-600' />
                                      ) : (
                                        <CalendarToday className='size-5 text-gray-600 mr-6' />
                                      )}
                                    </InputAdornment>
                                  ),
                                },
                              }}
                              fullWidth
                              size='small'
                              InputLabelProps={{ shrink: true }}
                            />
                          }
                        />
                        <style>
                          {`
           .react-datepicker__navigation {
           display: none !important;}
           .react-datepicker__current-month {
           display: none !important;
           }`}
                        </style>
                        {submitted && (
                          <div className='text-red-600 mb-0 text-sm '>
                            Attendance submitted
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                  <Button
                    type='submit'
                    loading={Loading}
                    variant='contained'
                    className='  rounded max-w-fit  h-10   font-medium  text-white min-w-[100px] '
                    loadingIndicator={
                      <div className='font-bold'>Loading...</div>
                    }
                  >
                    {!Loading ? 'Search ' : ''}
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
      <Modal
        open={change}
        onClose={() => {
          setChange(false);
          setCurrentValues(searchValues);
        }}
      >
        <div className='absolute top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-xl min-w-80'>
          <p className='text-xl'>There are some modificaitons ! inside</p>
          <p className='text-center text-red-400'>
            Would You like to ignore changes ?
          </p>
          <div className='flex justify-around mt-6'>
            <Button
              variant='outlined'
              color='error'
              onClick={() => {
                setChange(false);
                setCurrentValues(searchValues);
              }}
            >
              NO
            </Button>
            <Button
              variant='outlined'
              color='success'
              onClick={() => {
                setSearchValues(currentValues);
                getStudents(currentValues);
                setChange(false);
                setHasChanges(false);
              }}
            >
              YES
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
